

define(['angular', 'squid/index', './directive', 'pages/xo-sidebar/route', 'xo-guest-components/src/guest-upgrade-interstitial/route', 'xo-guest-components/src/guest-existing-member-interstitial/route', 'xo-guest-components/src/continue-3ds-redirect/route'], function (angular, squid) {
  (function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
  })(window.angular);
  angular.module('hermes.page.xo-guest.route', ['squid', 'hermes.page.xo-guest.directive', 'hermes.page.xo-sidebar.route']).factory('$GuestRoute', function ($ComponentRoute) {
    return $ComponentRoute.extend('GuestRoute', {
      name: 'guest',
      directive: 'xo-guest',
      // Uncomment the following line to suffix content to
      // the title of the page
      // Base title is 'PayPal Checkout'
      // titleContent: 'accountCreationGuest.heading',

      trackingData: {
        fptiState: 'guest_xo',
        trackStateExit: false,
        templateName: 'guest.dust',
        pageGoal: 'Payment Start',
        pageQualifier: 'guest',
        buzname: {
          'guest': {
            'pagename': '%::fullpage-guest',
            'pagename2': '%::fullpage-guest:member:hermes:',
            'version': 'guest:%:'
          },
          'signup': {
            'pagename': '%::fullpage-guestSignup',
            'pagename2': '%::fullpage-guestSignup:member:hermes:',
            'version': 'guestSignup:%:'
          }
          // More page qualifiers come here...
        }
      },
      children: [{
        name: '$SidebarRoute',
        attributes: {
          'back-uri': 'backUri',
          'parent-model': 'singleStepModel'
        }
      }, {
        name: '$GuestUpgradeInterstitialRoute',
        attributes: {
          token: 'token',
          'parent-model': 'singleStepModel'
        }
      }, {
        name: '$GuestExistingMemberInterstitialRoute',
        attributes: {
          token: 'token',
          'parent-model': 'singleStepModel'
        }
      },
      /**
       * Url endpoint: checkout/guest/continue3DSRedirect
       * This endpoint is need to call existing client method `onComplete3DSHandler` 
       * so that once after complete3DS success in full page redirection of bank page to 
       * continue the 3ds process.
       */
      {
        name: '$Continue3DSRedirectRoute',
        attributes: {
          token: 'token',
          'parent-model': 'singleStepModel'
        }
      }]
    });
  });
});


//////////////////
// WEBPACK FOOTER
// ./pages/xo-guest/route.js
// module id = ./pages/xo-guest/route.js
// module chunks = 0